import React from 'react';
import './newsletter-alert.css';

const SuccessIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M5 12.5 9.2 17 19 7" />
  </svg>
);

const ErrorIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 8v5M12 17h.01" />
    <circle cx="12" cy="12" r="9" />
  </svg>
);

const NewsletterAlert = ({ open, type = 'success', message, onClose }) => {
  if (!open) return null;

  const isError = type === 'error';

  return (
    <aside
      className={`newsletter-alert newsletter-alert--${type}`}
      role={isError ? 'alert' : 'status'}
      aria-live={isError ? 'assertive' : 'polite'}
      aria-atomic="true"
    >
      <div className="newsletter-alert__mark">
        {isError ? <ErrorIcon /> : <SuccessIcon />}
      </div>
      <div className="newsletter-alert__copy">
        <span className="newsletter-alert__eyebrow">Guhso newsletter</span>
        <strong>{isError ? 'We could not add you' : 'You’re almost there'}</strong>
        <p>{message}</p>
        {!isError && <small>Open the email and confirm your address to complete signup.</small>}
      </div>
      <button type="button" className="newsletter-alert__close" onClick={onClose} aria-label="Dismiss newsletter notification">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m7 7 10 10M17 7 7 17" /></svg>
      </button>
    </aside>
  );
};

export default NewsletterAlert;
